import { Component } from '@angular/core';

@Component({
  selector: 'atlas-ink-bar',
  templateUrl: './ink-bar.component.html',
  styleUrls: ['./ink-bar.component.scss'],
  standalone: false,
})
export class InkBarComponent {}
